import { Injectable } from '@angular/core';

@Injectable()
export class ArrayHelpersService {
  constructor() {}

  findIndex(array: any, condition: any, attribute: string): number {
    return array.findIndex((item) => item[attribute] === condition);
  }
}
